export default __webpack_public_path__ + "static/media/Group102912.82b3f76e.svg";